<template>
    <div id="app">
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>
    const default_layout = "default"

    import {mapGetters} from 'vuex'

    export default {
        computed: {
            layout() {
                return (this.$route.meta.layout || default_layout) + '-layout'
            },
            ...mapGetters({isSubscriptionOpen: 'isSubscriptionOpen', currentFamily: 'currentFamily'})
        },
        updated() {
            if (this.currentFamily) {
                this.$http.get('/options/1')
                    .then((response) => {
                        let dateFrom = response.data.date_from
                        let dateTo = response.data.date_to

                        this.$store.dispatch('updateSubscription', this.$isDateInRange(dateFrom, dateTo))

                    })
                    .catch(err => {
                        if (this.$isSignatureExpired(err.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            }


        },
        created() {
            if (this.currentFamily) {
                this.$http.get('/options/1')
                    .then((response) => {
                        let dateFrom = response.data.date_from
                        let dateTo = response.data.date_to
                        let currentYear = response.data.current_year

                        this.$store.dispatch('updateSubscription', this.$isDateInRange(dateFrom, dateTo))
                        this.$store.dispatch('setCurrentYear', currentYear)
                    })
                    .catch(err => {
                        if (this.$isSignatureExpired(err.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            }

        }

    }

</script>


<style lang="scss">
    @import 'src/assets/style/style.scss';

    .ps__rail-y:hover {
        background: var(--surface-color-dark) !important;
    }

    .ps__thumb-y {
        background: var(--color-grey) !important;
    }
</style>
